import React, { useState, useEffect } from 'react';

import { useSelector, shallowEqual } from 'react-redux';
import Questions from 'screens/admin/common/QuestionBank';
import { selectQuestionDetails } from 'selectors/questionDetails';

import { getOrganizationTags } from 'services/admin';
import { showQuestionDetails } from 'services/questionDetails';

const QuestionBank = () => {
  const [drivers, setDrivers] = useState([]);
  const tagType = 'ENGAGEMENT_DRIVER';
  const { updatedQuestion } = useSelector(selectQuestionDetails, shallowEqual);

  const getDriversList = () => {
    getOrganizationTags({ teamId: -1, tagType }).then((orgTags) => {
      setDrivers(orgTags.filter((tag) => tag.active));
    });
  };

  useEffect(getDriversList, []);

  return (
    <Questions
      source="engagement"
      showQuestionDetails={showQuestionDetails}
      updatedQuestion={updatedQuestion}
      drivers={drivers}
      subheadingEl={['Design and view sample / archived questions for your engagement surveys']}
    />
  );
};

export default QuestionBank;
